import React from "react";
import classes from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import classNames from "classnames";

interface DetailLayoutProps {
    children: React.ReactNode;
    breadcrumb: string;
}

export default function EvaluateLayout({
    children,
    breadcrumb
}: DetailLayoutProps) {
    return (
        <div className={classNames(classes.root, "PopupContainer")}>
            <Header />

            <div className={classes.main}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <Link to="/">首页</Link>
                    </Breadcrumb.Item>

                    <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                </Breadcrumb>

                <div className={classes.body}>{children}</div>
            </div>
        </div>
    );
}
